const config = {
    pubKey: "789aa4f8888f20fb0781f6f6bb94b0fe",
    algorithm: "XXTEA",
    // encryptParam: true
    encryptParam: process.env.VUE_APP_ENCRY_PARAM == '1'
};
  
export default {
  config
}



// WEBPACK FOOTER //
// ./src/config/common-config.js